import type { PaymentByRegionConfig, PaymentConfig } from '~/projects/types';

export function resolvePaymentConfigForCountry(
  map: PaymentByRegionConfig,
  countryCode: string,
): PaymentConfig {
  const trimmed = countryCode?.trim() ?? '';
  // Geo often resolves after first paint; empty string must not match a real ISO key.
  if (!trimmed) {
    return map.default;
  }

  const iso = trimmed.toUpperCase();
  const fromMap = (map as Record<string, PaymentConfig | undefined>)[iso];
  if (fromMap) {
    return fromMap;
  }

  return map.default;
}
